import React, { useMemo } from "react";
import { useScheduleTemplates } from "@api/scheduleTemplate.api";
import { BaseFilterProps } from "../../lib";
import { OptionsMultiselectFilter } from "./OptionsMultiselectFilter";
import { buildScheduleTemplateOptions } from "./schedulesReportFilterOptions";

export const SchedulesReportTemplateFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: templates } = useScheduleTemplates({
        includeMilestone: true,
    });
    const options = useMemo(
        () => buildScheduleTemplateOptions(templates ?? []),
        [templates],
    );

    return (
        <OptionsMultiselectFilter
            options={options}
            selectedIds={filters.scheduleTemplateIds ?? []}
            onChange={(scheduleTemplateIds) =>
                onChange({ scheduleTemplateIds })
            }
            name="schedulesReportTemplate"
        />
    );
};
